import { Component, OnInit } from '@angular/core'
import { AppConfigService } from 'app/shared/services/app-config.service'
import { ContentLayoutComponent } from '../content-layout.component'
import { RoleConstants } from './../../../shared/generated/generated'
import { CurrentUserService } from './../../../shared/services/current-user.service'
import { ManageUsersService } from './../../../shared/services/manage-users-service'
import { PermissionService } from './../../../shared/services/permission.service'
import { NgFor, NgIf } from '@angular/common'
import { AppMenuItemComponent } from './app-menu-item.component'

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  standalone: true,
  imports: [NgFor, NgIf, AppMenuItemComponent],
})
export class AppMenuComponent implements OnInit {
  model!: any[]

  constructor(
    public contentLayout: ContentLayoutComponent,
    public manageUsersService: ManageUsersService,
    public currentUserService: CurrentUserService,
    private permissionService: PermissionService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit() {
    this.currentUserService.user$.subscribe((data) => {
      this.setMenuModel()
    })

    this.setMenuModel()
  }

  addHomeMenuItems() {
    this.model.push({
      label: 'Home',
      items: [
        { label: 'Dashboard', icon: 'fa-solid fa-house', routerLink: ['/'] },
        {
          label: 'Documentation',
          icon: 'pi pi-fw pi-question',
          routerLink: ['documentation'],
        },
         {
          label: 'Report',
          icon: 'fa-solid fa-chart-column',
          routerLink: ['/admin/report-redirect'],
        },
      ],
    })
  }

  getSystemAdminMenuItem() {
    let systemAdminMenuItems = []

    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'System Logs',
        icon: 'fa-solid fa-bug',
        routerLink: ['/admin/system-logs'],
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'User Logs',
        icon: 'fa-solid fa-user-shield',
        routerLink: ['/admin/user-logs'],
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'Email Logs',
        icon: 'fa-solid fa-envelope',
        routerLink: ['/admin/email-logs'],
      })
    }
    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'Manage Emails',
        icon: 'fa-solid fa-envelope',
        routerLink: ['/admin/manage-emails'],
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'Swagger',
        icon: 'fa-regular fa-file-code',
        url: this.appConfigService.getApiUrlWithEndpoint('swagger'),
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'Hangfire',
        icon: 'fa-solid fa-person-running',
        url: this.appConfigService.getApiUrlWithEndpoint('hangfire'),
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.superAdmin])) {
      systemAdminMenuItems.push({
        label: 'Health Check',
        icon: 'fa-solid fa-heart-pulse',
        url: this.appConfigService.getApiUrlWithEndpoint('healthchecks-ui#/healthchecks/'),
      })
    }

    if (systemAdminMenuItems && systemAdminMenuItems.length > 0) {
      return {
        label: 'System Admin',
        icon: 'fa-solid fa-toolbox',
        items: systemAdminMenuItems,
      }
    }
  }

  addAdministrationMenuItems() {
    let adminMenuItems = []

    if (this.permissionService.doesUserHavePermission([RoleConstants.admin])) {
      adminMenuItems.push({
        label: 'Global Messages',
        icon: 'fa-solid fa-bell',
        routerLink: ['/admin/manage-global-messages'],
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.manageUsers])) {
      adminMenuItems.push({
        label: 'Manage Users',
        icon: 'fa-solid fa-user-gear',
        badge: 0,
        routerLink: ['/admin/manage-users'],
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.manageWeighStations])) {
      adminMenuItems.push({
        label: 'Manage Weigh Stations',
        icon: 'fa-solid fa-user-gear',
        badge: 0,
        routerLink: ['/admin/manage-weigh-stations'],
      })
    }

    if (this.permissionService.doesUserHavePermission([RoleConstants.admin])) {
      adminMenuItems.push({
        label: 'Manage Types',
        icon: 'fa-solid fa-list',
        routerLink: ['/admin/manage-types'],
      })
    }

    let systemAdminMenuItem = this.getSystemAdminMenuItem()

    if (systemAdminMenuItem && systemAdminMenuItem.items && systemAdminMenuItem.items.length) {
      adminMenuItems.push(systemAdminMenuItem)
    }

    if (adminMenuItems && adminMenuItems.length > 0) {
      this.model.push({
        label: 'Administration',
        items: adminMenuItems,
      })
    }
  }

  setMenuModel() {
    this.model = []

    this.addHomeMenuItems()
    this.addAdministrationMenuItems()

    if (this.permissionService.doesUserHavePermission([RoleConstants.manageUsers])) {
      this.manageUsersService.getCountOfPendingUsers()
      this.manageUsersService.pendingUserCount$.subscribe((data) => {
        this.model.find((x) => x.label == 'Administration').items.find((x) => x.label == 'Manage Users').badge = data
      })
    }
  }

  onKeydown(event: KeyboardEvent) {
    const nodeElement = <HTMLDivElement>event.target
    if (event.code === 'Enter' || event.code === 'Space') {
      nodeElement.click()
      event.preventDefault()
    }
  }

  redirectToReport(){
    alert('This feature is not implemented yet. Please check back later.' )
  }
}
